import { LandingPageResponse } from '@bgea-js/form-templates';
import customConfirmationEaster from "../../../../src/content/easter-from-israel/customConfirmation";
import * as React from 'react';
export default {
  LandingPageResponse,
  customConfirmationEaster,
  React
};